<template>
  <div class="mobile-footer-box">
    <!-- content -->
    <div class="mobile-info-box">
      <div class="mobile-item">
        <div class="mobile-item-title-box">
          <img class="mobile-icon" src="@/assets/footer/icon1.png" alt="" />
          <div class="mobile-title">河北总部</div>
        </div>
        <div class="mobile-text-box">
          <div class="mobile-text">衡水市桃城区城市杰座A 座 11 层</div>
        </div>

        <div class="mobile-item">
          <div class="mobile-item-title-box">
            <img class="mobile-icon" src="@/assets/footer/icon1.png" alt="" />
            <div class="mobile-title">北京分公司</div>
          </div>
          <div class="mobile-text-box">
            <div class="mobile-text">北京市房山区长阳镇溪雅苑一区12号1层</div>
          </div>
        </div>
      </div>

      <div class="mobile-item">
        <div class="mobile-item-title-box">
          <img
            class="mobile-icon"
            style="padding-bottom: 0.25rem"
            src="@/assets/footer/icon2.png"
            alt=""
          />
          <div class="mobile-title">联系电话</div>
        </div>
        <div class="mobile-text-box">
          <div class="mobile-text">18231817521(闫丽琴）</div>
          <div class="mobile-text">18330855518(冷建斐）</div>
        </div>
      </div>

      <div class="mobile-item">
        <div class="mobile-item-title-box">
          <img
            class="mobile-icon"
            style="width: 1.75rem; height: 1.5rem"
            src="@/assets/footer/icon3.png"
            alt=""
          />
          <div class="mobile-title">邮箱</div>
        </div>
        <div class="mobile-text-box">
          <div class="mobile-text">shanmuzhi@shanmuzhi .com</div>
        </div>
      </div>

      <div class="mobile-item">
        <div class="mobile-item-title-box">
          <img
            class="mobile-icon"
            style="width: 1.90625rem; height: 1.46875rem"
            src="@/assets/footer/icon4.png"
          />
          <div class="mobile-title">关注我们</div>
        </div>
        <div class="mobile-text-box">
          <div class="mobile-text">扫码关注公众号</div>
        </div>
        <div class="mobile-qrcode">
          <img src="@/assets/qrcode.png" alt="" />
        </div>
      </div>
    </div>

    <!-- record -->
    <div class="mobile-record-box">
      <div class="mobile-left">CopyRight @ 2017-2025 shanmuzhi.com Design</div>
      <div class="mobile-right" style="cursor: pointer" @click="toICP">
        All Rights Reserved 备案号：{{ ICPtext() }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      routeList: [
        { title: 'Home 首页', name: 'home' },
        { title: 'Business 业务', name: 'business' },
        { title: 'Case 案例', name: 'case' },
        { title: 'About 关于', name: 'about' },
        { title: 'Team 团队', name: 'team' },
        { title: 'Contact 联系', name: 'contact' },
      ],
    };
  },
  computed: {
    active() {
      return this.$store.state.route.activeRoute;
    },
  },
  methods: {
    toHref(item) {
      this.$router.push({ name: item.name });
      this.$store.dispatch('updateActiveRoute', item.name);
    },
  },
};
</script>

<style lang="scss" scoped>
@import './index.scss';
</style>
